import axios from "axios";
import API_BASE_URL from "../../../../config/apiConfig";

// src/services/api/careGapService.js (misma ubicación del anterior)
export const getPCPChangesByCip = async (cipId) => {
  try {
    const url = `${API_BASE_URL}/api/PatientInfo/${encodeURIComponent(cipId)}/care-gaps`;

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data; // Será un array de CareGapDetailDto
  } catch (error) {
    console.error(`Error fetching care gaps for CIP ${cipId}:`, error);
    throw error;
  }
};
